import React, { useMemo } from 'react'
import { HelpDrawerWithAccordion } from '@labrav/common'
import { useStyles } from './MicrosoftFormFAQs.styles'
import { getFaqItemsForItem } from './MicrosoftFormFAQs.data'
import { MicrosoftFormFAQsItem } from './MicrosoftFormFAQs.types'

export { MicrosoftFormFAQsItem }

interface MicrosoftFormFAQsProps {
  item?: MicrosoftFormFAQsItem
}

const MicrosoftFormFAQsComponent: React.FC<MicrosoftFormFAQsProps> = ({
  item,
}) => {
  const { classes } = useStyles()
  const faqItems = useMemo(
    () => getFaqItemsForItem(item, classes),
    [item, classes]
  )

  return (
    <HelpDrawerWithAccordion
      headerTitle="Help & FAQs"
      faqItems={faqItems}
      divider
    />
  )
}

export const MicrosoftFormFAQs = React.memo(MicrosoftFormFAQsComponent)
